/* eslint no-console:0 */
// this file contains javascript for lightbox modal layout (e.g. GPSR info)

/* js stuff */
import * as bootstrap from "bootstrap";

document.addEventListener('turbo:load', startApp)

function startApp(event) {

}
